import { $Qll, $Q } from "../utils/query-selector";
import { fetchMainProduct } from "./product-subscriptions";
import { checkModalCart, fetchModalProduct } from "./modal-cart";

const getProductFormControls = (scope, name) => {
  const productForm = scope?.querySelector('.main-product__subscriptions-form');
  const formId = productForm?.getAttribute('id');

  if (!formId) {
    return $Qll(`.main-product__subscriptions-form [name="${name}"]`, scope || document);
  }

  return $Qll(
    `[data-main-product-form-control="${formId}"][name="${name}"], form[id="${formId}"] [name="${name}"]`,
    scope || document
  );
};

export const initKlaviyoBtn = (query = "") => {
  const klaviyoBtns = $Qll(`${query}.btn-of-stock`);

  if (!klaviyoBtns) return;

  klaviyoBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      let dataHandle = btn.dataset.productHandle;
      let dataTarget = $Q(
        `[data-klaviyo-handle="${dataHandle}"] .klaviyo-bis-trigger`
      );

      if (!dataTarget) return;
      checkModalCart();
      dataTarget.click();
    });
  });
};

/**
 * This function updates the regular and compare prices in main product, modal cart and sticky cart
 * @param {String} query - This is the query for regular or compare price
 * @returns
 */

export const initBundleOptions = (query = "") => {
  const radios = $Qll(`${query}.js-variant-radio`);
  const scope = $Q(query.trim()) || document;
  const formInputs = getProductFormControls(scope, 'id');

  if (!radios) return;

  radios.forEach((radio) => {
    radio.addEventListener("click", () => {
      const activeOption = $Q(`${query}.jc-variant-option.active`);
      let subscribtionsRadio = $Q(
        `${query}input[name="subscriptions"]:checked`
      );
      let modalActive = $Q(".modal-cart")?.dataset.active;
      let variants = JSON.parse($Q(`${query}#variants`).value);
      let zeroItem = $Q(`${query}.js-variant-radio[value="Abonnement"]`);
      const firstBundlesInput = $Qll(`${query}.js-variant-radio`);
      const option1 = activeOption?.dataset.option;
      let option2 = radio.value;

      if (zeroItem && zeroItem.value == option2) {
        option2 = $Q(`${query}.js-variant-radio[value="x1"]`).value;
      }

      if (subscribtionsRadio.value == "subscribe") {
        if (firstBundlesInput[0]) {
          firstBundlesInput[0].checked = true;
        }

        if (zeroItem) {
          option2 = "Abonnement";
        } else {
          option2 = $Q(`${query}.js-variant-radio:checked`).value;
        }
      }

      function findProductId(option1, option2) {
        const variant = variants.find(
          (p) => p.option1 === option1 && p.option2 === option2
        );
        return variant ? variant : null;
      }

      const variantObject = findProductId(option1, option2);

      if (formInputs.length > 0) {
        formInputs.forEach((item) => {
          item.value = variantObject.id;
        });
      }

      if (modalActive == "true") {
        let modalCartWindow = $Q(".modal-cart");

        fetchModalProduct(variantObject.id, modalCartWindow, true);
      } else {
        fetchMainProduct(variantObject.id, false, true);
      }

      let featuredMedia = variantObject?.featured_media?.id;
      if (!featuredMedia) return;

      let toggleSliderItem = $Q(`${query}[data-media-id="${featuredMedia}"]`);
      let allMediaItems = $Qll(`${query}[data-media-id]`);
      let slideIndex = parseInt(
        Array.prototype.indexOf.call(allMediaItems, toggleSliderItem)
      );

      if (modalActive == "true" && window.mainSwiperModal) {
        window.mainSwiperModal.slideTo(slideIndex);
      }
    });
  });
};

const parseEuroPrice = (value = "") => {
  const normalized = String(value)
    .replace(/[^\d,.-]/g, "")
    .replace(",", ".");
  const amount = Number.parseFloat(normalized);

  return Number.isFinite(amount) ? amount : 0;
};

const getDiscountPercentFromAmounts = (price, compareAtPrice) => {
  if (!(compareAtPrice > price) || !(compareAtPrice > 0)) return 0;

  return Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
};

const getVariantDiscountPercent = (option, variants = []) => {
  const variantId = Number(option?.dataset?.variant);
  const variantObject = variants.find((variant) => Number(variant.id) === variantId);

  if (variantObject) {
    return getDiscountPercentFromAmounts(
      Number(variantObject.price),
      Number(variantObject.compare_at_price)
    );
  }

  const datasetPercent = Number(option?.dataset?.discountPercent);
  if (Number.isFinite(datasetPercent)) {
    return datasetPercent;
  }

  return getDiscountPercentFromAmounts(
    parseEuroPrice(option?.dataset?.price),
    parseEuroPrice(option?.dataset?.comparePrice)
  );
};

const updateProductCardDiscountBadge = (cardEl, option, variants = []) => {
  if (!cardEl || !option) return;

  const discountBadge = cardEl.querySelector("[data-discount-badge]");
  const discountBadgeText = cardEl.querySelector("[data-discount-badge-text]");
  const discountPercent = getVariantDiscountPercent(option, variants);
  const hasDiscount = discountPercent > 0;

  if (discountBadge) {
    discountBadge.classList.toggle("jc-hidden", !hasDiscount);
    discountBadge.setAttribute("aria-hidden", hasDiscount ? "false" : "true");
  }

  if (discountBadgeText) {
    discountBadgeText.textContent = hasDiscount ? `-${discountPercent}%` : "";
  }
};

export const initOptionsToggle = () => {
  document.addEventListener(
    "click",
    (event) => {
      let targetElement = event.target;

      while (targetElement != null) {
        if (targetElement.matches(".jc-variant-option")) {
          event.preventDefault();

          let option = targetElement;
          let cardEl =
            option.closest(".js-product-card") || option.closest(".product-card");
          let optionParent =
            cardEl ||
            option.closest(".main-product") ||
            option.closest(".main-product-page");
          if (!optionParent) return;
          let options = Array.from(
            optionParent.querySelectorAll(".jc-variant-option")
          );
          let inputs = getProductFormControls($Q("#main-product__detail"), "id");
          let index = options.indexOf(targetElement);
          let currentVariant = option.dataset.variant;
          let currentOption = option.dataset.option;
          let newPrice = option.dataset.price;
          let newCompareAtPrice = option.dataset.comparePrice;
          let modalActive =
            document.querySelector(".modal-cart")?.dataset.active;
          let variantObjectId = option.dataset.variant;
          let ifBundles = document.querySelectorAll(".js-variant-radio");
          let variantsInput =
            (cardEl && cardEl.querySelector("#variants")) ||
            document.querySelector("#variants");
          let variants = JSON.parse(variantsInput.value);
          let maxQuantity = document.querySelector('#maxQuantity');
          let isMaxLimit = 0;
          let quantityBtn = document.querySelector('.jc-main-product-quantity');
  
          if (quantityBtn) {
           isMaxLimit = quantityBtn.dataset.maxLimit;
           quantityBtn.querySelector('input').value = 1;
          }
          if (isMaxLimit == 'true') {
            if (quantityBtn) {
              quantityBtn.querySelector('input').value = 1;
            }
  
            if (currentOption && maxQuantity) {
              if (currentOption.includes('x10')) {
                maxQuantity.innerHTML = 20;
                quantityBtn.querySelector('input').setAttribute('max', 20)
              } else {
                maxQuantity.innerHTML = 9;
                quantityBtn.querySelector('input').setAttribute('max', 9)
              }
            }
          }

          const subscriptionsFieldset = document.querySelector(
            "#jc-main-product__subscriptions"
          );

          if (cardEl) {
            const cardHead = cardEl.querySelector(".product-card__head");
            if (cardHead) {
              cardHead.setAttribute("data-variant", currentVariant);
            }

            const productImages = cardEl.querySelectorAll('[class^="productcard_image-"]');
            productImages.forEach((image) => {
              image.classList.add("jc-opacity-0");
            });

            let imageElement = cardEl.querySelector(".productcard_image-" + index);
            if (!imageElement) {
              imageElement = cardEl.querySelector(".productcard_image-0");
            }
            if (imageElement) {
              imageElement.classList.remove("jc-opacity-0");
            }

            const priceElement = cardEl.querySelector(".product-card__form-price");
            const hasComparePrice = Boolean(newCompareAtPrice?.trim());

            if (priceElement) {
              priceElement.innerHTML = newPrice;
              priceElement.classList.toggle("jc-text-cadmiumgreen", hasComparePrice);
            }

            const comparePriceElement = cardEl.querySelector(".product-card__form-compare-price");
            if (comparePriceElement) {
              comparePriceElement.innerHTML = hasComparePrice
                ? newCompareAtPrice
                : "";
              comparePriceElement.classList.toggle(
                "jc-hidden",
                !hasComparePrice
              );
            }

            updateProductCardDiscountBadge(cardEl, option, variants);
          }

          options.forEach((opt) => {
            opt.classList.remove("active");
          });

          option.classList.add("active");

          function setVariantId(variantObjectId, modalActive) {
            if (subscriptionsFieldset && ifBundles.length) {
              const variantScope =
                modalActive == "true"
                  ? $Q(".modal-cart")
                  : option.closest("#main-product__detail") ||
                    document;
              let zeroItem = $Q(`.js-variant-radio[value="Abonnement"]`, variantScope);
              let radio = $Q('input[name="subscriptions"]:checked', variantScope);
              let firstBundlesInput = $Qll(`.js-variant-radio`, variantScope);
              let option1 = currentOption;
              let option2 = $Q(".js-variant-radio:checked", variantScope)?.value;

              if (zeroItem && zeroItem.value == option2) {
                option2 = $Q(`.js-variant-radio[value="x1"]`, variantScope)?.value;
              }

              if (modalActive == "true") {
                zeroItem = $Q(
                  '.modal-cart .js-variant-radio[value="Abonnement"]'
                );
                variants = JSON.parse($Q(".modal-cart #variants").value);
                radio = $Q('.modal-cart input[name="subscriptions"]:checked');
                firstBundlesInput = $Qll(".modal-cart .js-variant-radio");
                option2 = $Q(".modal-cart .js-variant-radio:checked")?.value;

                if (zeroItem && zeroItem.value == option2) {
                  option2 = $Q(
                    `.modal-cart .js-variant-radio[value="x1"]`
                  )?.value;
                }

                inputs = getProductFormControls($Q(".modal-cart"), "id");
              }

              if (radio?.value == "subscribe") {
                const subscriptionInput =
                  zeroItem || Array.from(firstBundlesInput).find((input) => input.checked);

                if (subscriptionInput) {
                  subscriptionInput.checked = true;
                }

                if (zeroItem) {
                  option2 = "Abonnement";
                } else {
                  option2 = $Q(".js-variant-radio:checked", variantScope)?.value;
                }
              }

              function findProductId(option1, option2) {
                const variant = variants.find(
                  (p) => p.option1 === option1 && p.option2 === option2
                );
                return variant ? variant : null;
              }

              let variantObject = findProductId(option1, option2);

              if (variantObject) {
                variantObjectId = variantObject.id;
              }

              if (variantObject && variantObject.featured_media) {

                let featuredMedia = "";
                featuredMedia = variantObject.featured_media.id;
                let toggleSliderItem = $Q(`[data-media-id="${featuredMedia}"]`);

                if (!toggleSliderItem) return;

                let photoGrid = $Q("#photoSwipe");

                if (photoGrid && window.innerWidth >= 992) {
                  let itemToMove = photoGrid.querySelector(
                    `[data-media-id="${featuredMedia}"]`
                  );

                  if (itemToMove) {
                    photoGrid.prepend(itemToMove);
                  }
                }

                if (modalActive == "true") {
                  const elements = document.querySelectorAll(
                    ".modal-cart .jc-variant-option"
                  );
                  const activeElement = document.querySelector(
                    ".modal-cart .jc-variant-option.active"
                  );
                  const activeIndex =
                    Array.from(elements).indexOf(activeElement);

                  window.mainSwiperModal.slideTo(index);
                }
              }
            } else {
              function findItemByVariantId(items, currentVariant) {
                return items.find((item) => item.id === Number(currentVariant));
              }

              let variantObject = findItemByVariantId(variants, currentVariant);

              if (
                variantObject &&
                variantObject.featured_media &&
                window.innerWidth > 992
              ) {
                let featuredMedia = variantObject.featured_media.id;
                let photoGrid = $Q("#photoSwipe");
                if (photoGrid && window.innerWidth >= 992) {
                  let itemToMove = photoGrid.querySelector(
                    `[data-media-id="${featuredMedia}"]`
                  );

                  if (itemToMove) {
                    photoGrid.prepend(itemToMove);
                  }
                }
              }

              if (modalActive == "true") {
                window.mainSwiperModal.slideTo(index);
              }
            }

            if (window.innerWidth <= 992) {
              if (document.querySelector('#productMainSlider')) {
                window.MProductSwiper.slideTo(index);
              }
            }

            if (modalActive == "true") {
              window.mainSwiperModal.slideTo(index);
            }

            if (inputs.length > 0) {
              inputs.forEach((item) => {
                item.value = variantObjectId;
              });
            }

            return variantObjectId;
          }

          let selectedVariantId = setVariantId(variantObjectId, modalActive);

          if (modalActive === "false") {
            if (option.closest(".product-card")) return;
            fetchMainProduct(selectedVariantId, false, false);
            
          } else {
            const modalCart = $Q(".modal-cart");
            // const isBundles = $Q('.modal-cart #bundle_options') ? true : false;

            fetchMainProduct(
              selectedVariantId,
              modalActive && modalCart,
              false
            );
          }
        }
        targetElement = targetElement.parentElement;
      }
    },
    false
  );
};
